"use client";

import React from "react";
import { AlertTriangle } from "lucide-react";

type ErrorMessageProps = {
  title?: string;
  message?: string;
  handleAction?: () => void;
  buttonText?: string;
  redirectUrl?: string;
};

export function ErrorMessage({
  title = "Something went wrong",
  message = "Please try again.",
  handleAction,
  buttonText = "Reload",
  redirectUrl,
}: ErrorMessageProps): React.JSX.Element {
  const handleButtonAction = (): void => {
    if (handleAction) return handleAction();
    if (typeof window !== "undefined") {
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }
      window.location.reload();
    }
  };

  return (
    <div className="min-w-full max-w-xl mx-auto rounded-xl border border-slate-200 bg-white/80 p-6 shadow-sm backdrop-blur">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-red-50 p-2 text-red-600">
          <AlertTriangle className="h-5 w-5" />
        </div>
        <div className="flex-1 space-y-2">
          <div>
            <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
            <p className="text-sm text-slate-600">{message}</p>
          </div>
          <div className="pt-2">
            <button
              type="button"
              onClick={handleButtonAction}
              className="cursor-pointer inline-flex items-center gap-1 rounded-lg bg-red-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-700 focus:outline-none"
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
